<template>
    <SearchLayout :get-data="readUrlsByKeyword()" />
</template>

<script>
    import SearchLayout from '@/components/Search/SearchLayout.vue'
    import elasticUrlsRepository from '@/api/v2/elastic/url'

    export default {
        name: 'SearchByKeywords',
        title: 'searchform.searchByKeyword.title',
        components: {
            SearchLayout
        },
        methods: {
            readUrlsByKeyword() {
                return elasticUrlsRepository.readUrlsByKeyword
            }
        }
    }
</script>
